import React, { useState } from 'react';
import { DocumentationFile, useLazyWizardPreviewFileQuery } from '../../../../../graphql/graphql';
import { useAppContext } from '../../../../../Services/AppContext';
import { prepareDocumentationFileForMediaViewer } from '../../../../ECard/Services/eCardFile.service';
import MediaViewerModal from '../../../../Utils/MediaViewer/MediaViewerModal';
import Button from '../../../../BaseModule/Components/Button';
import useNotification from '../../../../../Hooks/useNotification';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	title: string;
	fileId: string;
}

const WizardFilePreviewButton: React.FC<Props> = ({ title, fileId }) => {
	const { socketUrl } = useAppContext();
	const { showNotificationAlert } = useNotification();
	const { t } = useTranslation();
	const [getFilePreview] = useLazyWizardPreviewFileQuery();

	const [fileItem, setFileItem] = useState<DocumentationFile | undefined>(
		undefined,
	);

	const handlePreviewFile = async () => {
		const { data, isLoading } = await getFilePreview({ fileId });
		if (!isLoading) {
			const fileItem = data?.documentationFiles?.data?.[0] || undefined;
			setFileItem(fileItem);
			if (!fileItem) {
				showNotificationAlert({
					content: t('component.wizardFilePreviewButton.fileNotFound'),
				});
			}
		}
	};

	return (
		<>
			<Button onClick={handlePreviewFile} text={title} className='light' />
			{fileItem && (
				<MediaViewerModal
					opened
					onClose={() => setFileItem(undefined)}
					file={prepareDocumentationFileForMediaViewer(fileItem, socketUrl)}
				/>
			)}
		</>
	);
};

export default WizardFilePreviewButton;